import _ from 'lodash'

const hasPermission = (permissions, requiredPermission) => {
  if (Array.isArray(requiredPermission)) {
    return requiredPermission.every((permission) => _.includes(permissions, permission))
  }

  return _.includes(permissions, requiredPermission)
}

export default hasPermission
